import { ExpeditionStatus } from "../../graphql/generated";
import { TYPE_LABEL } from "./vessels.config";
import type { VesselDetail, VesselListMember } from "./vessels.types";

export function activeExpeditionName(vessel: VesselListMember | VesselDetail): string | undefined {
  return vessel.expeditionAssignments.find((ea) => ea.expedition.status === ExpeditionStatus.Active)?.expedition.name;
}

export function berthsValue(berths: number | null | undefined, maxPassengers: number | null | undefined): string {
  if (berths == null) return "—";
  return maxPassengers != null ? `${berths} / ${maxPassengers}` : String(berths);
}

export function makeModelSub(make: string | null | undefined, model: string | null | undefined): string {
  if (make && model) return `${make} ${model}`;
  return make ?? "—";
}

export function buildSpecItems(v: VesselDetail): Array<{ label: string; value: string }> {
  return (
    [
      { label: "Type", value: v.vesselType ? TYPE_LABEL[v.vesselType] : null },
      { label: "LOA", value: v.lengthM != null ? `${v.lengthM} m` : null },
      { label: "Beam", value: v.beamM != null ? `${v.beamM} m` : null },
      { label: "Draft", value: v.draftM != null ? `${v.draftM} m` : null },
      {
        label: "Berths",
        value: v.berths != null ? `${v.berths}${v.maxPassengers != null ? ` (max ${v.maxPassengers})` : ""}` : null,
      },
      { label: "Engine", value: v.enginePowerKw != null ? `${v.enginePowerKw} kW` : null },
      { label: "Fuel", value: v.fuelCapacityL != null ? `${v.fuelCapacityL} L` : null },
      { label: "Water", value: v.waterCapacityL != null ? `${v.waterCapacityL} L` : null },
      { label: "Flag", value: v.flagState ?? null },
      { label: "Home port", value: v.homePort ?? null },
      { label: "Registration", value: v.registration ?? null },
      { label: "Call sign", value: v.callSign ?? null },
      { label: "MMSI", value: v.mmsiNumber ?? null },
    ] as Array<{ label: string; value: string | null }>
  ).filter((item): item is { label: string; value: string } => item.value !== null);
}
